<template>
  <div class="solution">
    <top-nav></top-nav>
    <!-- <banner :bgImage="bgImage"></banner> -->
<div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">
          <br><br><br><br> 由此开启</div>
    </div>
    <ul class="solutionBox clearfix">
      <li
        v-for="(item,index) in solutionArr"
        :key="index"
        class="solution-item"
        @mouseenter="item.showMask = true"
        @mouseleave="item.showMask = false"
        @click="toDetail(item.url)"
      >
        <transition name="slide-fade">
          <div class="solution-info" v-show="item.showMask">
            <p class="solution-title">{{item.title}}</p>
            <div class="solution-profile">
              {{item.content}}
            </div>
          </div>
        </transition>
        <img :src="item.img" alt="" srcset="" />
      </li>
      
      <li class="solution-item" @click="toCase()">
        <img src="../../../static/images/solutionPic.jpg" />
      </li>
    </ul>

    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solution",
  data() {
    return {
      bgImage:'../../../static/images/solutionCaseBanner.jpg',
      solutionArr:[
        {
          title: '智慧政务',
          content: '智慧政务作为政府的对外服务窗口，方便互联网用户了解政府最新资讯，以及办理各项业务，提升政府服务效率，而互联网用户归类包括IPv4和IPv6用户，所以需要实现对IPv6用户的同步覆盖。',
          img: '../../../static/images/solutionPic2.jpg',
          url:'/solutionCase1',
          showMask: false,
        },
        {
          title: '平安城市',
          content: '利用IPv6海量地址的特征实现全网安全监控摄像头统一编址，解决多个监控网络无法互通的问题，实现在原有IPv4监控平台访问、管理、存储IPv6摄像头及视频的功能。',
          img: '../../../static/images/solutionPic3.jpg',
          url:'/solutionCase2',
          showMask: false,
        },
        {
          title: '智慧教育',
          content: '提供教学、科研和综合信息服务的宽带多媒体网络，跟踪和使用最新的IPv6的应用和技术，便于科研探索，辅助培育IPv6的技术型人才。',
          img: '../../../static/images/solutionPic5.jpg',
          url:'/solutionCase3',
          showMask: false,
        },
        {
          title: '无线城市',
          content: '使用无线宽带技术实现城市热点区域的无线通信覆盖，向公众提供随时随地接入和高速度的无线网络，充分发挥IPv6即接即用的特性。',
          img: '../../../static/images/solutionPic1.jpg',
          url:'/solutionCase4',
          showMask: false,
        },
        {
          title: '智慧医疗',
          content: '通过区域综合信息平台的互联互通、资源共享，实现公共卫生、医疗服务和卫生管理的一体化。解决不同医院之间的医疗资料系统无法互通的问题。',
          img: '../../../static/images/solutionPic4.jpg',
          url:'/solutionCase5',
          showMask: false,
        },
      ]
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {
    toDetail(url){
      this.$router.push({path: url})
    },
    toCase(){
      this.$router.push({path: '/case'})
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solution {
  .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner.jpg?011902) no-repeat center;
         height: 500px;
         .solutionCaseBannerIn{
           height: 400px;
         }
    }
  .solutionBox {
    width: 1200px;
    margin: 95px auto;
    .solution-item {
      width: 400px;
      height: 250px;
      line-height: 250px;
      text-align: center;
      font-size: 30px;
      color: #fff;
      float: left;
      overflow: hidden;
      background-color: #313133;
      position: relative;
      cursor: pointer;
      .solution-info {
        width: 100%;
        height: 250px;
        background-color: rgba(115, 169, 241, 0.8);
        position: absolute;
        top: 0;
        left: 0;
        padding: 40px;
        .solution-title {
          width: 100%;
          line-height: 24px;
          font-size: 24px;
          color: #fff;
          padding-bottom: 15px;
          text-align: left;
        }
        .solution-profile {
          width: 100%;
          line-height: 28px;
          font-size: 15px;
          color: #fff;
          text-align: justify;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solution.vue